export const enum PlanInterval {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}
